module.exports = __webpack_public_path__ + "static/media/gal4.082d0505.jpg";